import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizationRights } from './organization-rights';
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { CurrentUserRolesProvider } from "./current-user-roles-provider";
import { Organization } from "../../common/models/organization";
import { MenuItem } from "../../common/models/menu";
import { catchError, map } from "rxjs/operators";
import { error } from "@angular/compiler-cli/src/transformers/util";
import { OrganizationsProvider } from "./organizations-provider";
import { Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class OrganizationsNavigationProvider {
    constructor(
        private _conf: ConfigProvider,
        private _router: Router,
        private _utils: UtilsProvider,
        private organizationProvider: OrganizationsProvider,
        private _currentUserRoles: CurrentUserRolesProvider
    ) { }

    public getOrganisationFromRoute(route: string | null = null): Observable<Organization | null> {
        if (!route) {
            route = this._router.url;
        }
        const urlParts: string[] = route.split('/');
        if (urlParts.length >= 2) {
            const code: string = urlParts[1];
            return this.organizationProvider.getByCode(code).pipe(
                catchError((error) => {
                    return of(null);
                })
            );
        } else {
            return of(null); // If the URL does not have enough parts, return an Observable that emits null
        }
    }
    public getMenus(level: 'root' | 'settings', extra: GetMenuExtra): MenuItem[] {
        const menus: MenuItem[] = [];

        switch (level) {

        case 'root':
            menus.push({
                title: 'Home',
                icon: 'home',
                url: '/' + extra.organization.code,
                onClicked: null
            });

            menus.push({
                title: 'Exercices',
                icon: 'offline_bolt',
                url: '/' + extra.organization.code + '/exercices',
                onClicked: null
            });

            if (extra.rights.EDIT) {
                menus.push({
                    title: 'Settings',
                    icon: 'settings',
                    url: '/' + extra.organization.code + '/settings',
                    onClicked: null
                });
            }
            break;

        case 'settings':
            if (extra.rights.EDIT) {
                menus.push({
                    title: 'Organization_settings',
                    icon: 'create',
                    url: '/' + extra.organization.code + '/settings',
                    onClicked: null
                });
                menus.push({
                    title: 'Users',
                    icon: 'people',
                    url: '/' + extra.organization.code + '/settings/users',
                    onClicked: null
                });
            }
            break;

        }

        return menus;
    }
}

export interface GetMenuExtra {
    organization: Organization;
    rights: OrganizationRights;
}
